/* eslint-disable */

import { Badge, Button, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue, Icon, Stack, useDisclosure, Input, SimpleGrid } from '@chakra-ui/react';
// Custom components   
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'
import * as React from 'react';
// Assets  
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import Invoice from "views/admin/main/ecommerce/orderDetails";
import InputField from 'components/fields/InputField';

import {
  PaginationState,
  createColumnHelper,
  ColumnFiltersState,
} from '@tanstack/react-table'
import { useForm } from 'react-hook-form';
import { getSessionCandidateId } from 'helpers/session';

type RowObj = {
  Anombre: string;
  id: number;
  fechahora: string;
  updatedAt: string;
  Mesa: number;
  meserosId: number;
  Meseros: [];
  Empresaid: number;
  PrecioTotal: string;
  createdAt: string;
  Estatus: boolean;
  actions: string;
};

export default function SearchTableOrders() {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [orden, setOrden] = React.useState(0);
  React.useState<PaginationState>({
    pageIndex: 0,
    pageSize: 6,
  })

  React.useEffect(() => {
    onOpen();
  }, []) //[table.getState().columnFilters[0]?.id])

  function onSubmit(values: any) {
    return new Promise(async (resolve) => {
      const formData = new FormData();
      for (var key in values) {
        console.warn(key)
        let value = values[key];
        formData.append(key, value);
      }

      const candidateId = getSessionCandidateId();
      if (candidateId) {
        formData.append('idCandidato', String(candidateId));
      }
      formData.append('Tipo', 'Ingreso');
      console.log(formData);

        // const response = await fetch(process.env.REACT_APP_URL_SERVER+'/session_valida',
        // {
        //   method: "GET",
        //    credentials:'include',
        // });
      const response = await fetch(process.env.REACT_APP_URL_SERVER+'/reg_fondos',
        {
          body: formData,
          method: "post",
          credentials: 'include',
        });
     alert('Agregado')
    })
  }

  return (
    <Flex
      direction='column'
      w='100%'
      overflowX={{ sm: "scroll", lg: "hidden" }}>


      <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>

            <ModalHeader>Ingreso de Fondos </ModalHeader>
            <ModalCloseButton />
            {/* <ModalBody>
              <Invoice id={orden}></Invoice>
            </ModalBody> */}

            <Flex direction="column" w="100%" ml='9'>
              <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                <Stack direction="column" gap="20px">
                  <InputField
                    mb="0px"
                    type='number'
                    id="Monto"
                    name="Monto"
                    placeholder="100"
                    label="Monto"
                    nombre="Monto"
                    registro={register}
                  />
                  <InputField
                    mb="0px"
                    type='text'
                    id="Concepto"
                    name="Concepto"
                    placeholder="----"
                    label="Concepto"
                    nombre="Concepto"
                    registro={register}
                  />
                </Stack>
              </SimpleGrid>
            </Flex>
            <ModalFooter>
              <Button colorScheme='red' mr={3} onClick={onClose}>
                Cerrar
              </Button>
              <Button colorScheme='green' mr={3} type='submit'>

                Guardar</Button>
            </ModalFooter>
          </form>

        </ModalContent>
      </Modal>
    </Flex>
  )

}
